module.exports = __webpack_public_path__ + "img/wedo04.d718b6b8.png";